import {app} from '../app.imba'
import {Habitat} from './habitat.imba'

# let energy = 12883
let levelforsteps = 22

let steps = 10000
let levelforenergy = 22

let harvestab = 'left'

def KiCap perc
	let cap 
	if app.EnergyFromSteps(steps, levelforenergy) * perc > app.DailyCap(0)
		cap = app.DailyCap(0)
	else cap = (app.EnergyFromSteps(steps, levelforenergy) * perc)
	return cap.toFixed(2)

def RemainEn perc
	let en
	if app.EnergyFromSteps(steps, levelforenergy) > (app.DailyCap(0) / perc)
		en = app.EnergyFromSteps(steps, levelforenergy) - (app.DailyCap(0) / perc)
	else en = 0
	return app.SpaceNum(Math.round(en))

def NeededSteps perc
	let st
	let energy = app.DailyCap(3) / perc
	st = app.SpaceNum(app.StepsForEnergy(energy, levelforsteps))
	return st

export tag Harvest
	<self>
		# harvest ki from steps
		<.block[g: 0]>
			<.harvest-tabs>
				<h2 .active=(harvestab == 'left') @click=(do harvestab = 'left')> app.trans.tab11[app.lg]
				<h2 .active=(harvestab == 'right') @click=(do harvestab = 'right')> app.trans.tab12[app.lg]
			if harvestab == 'left'
				<form>
					<label> app.trans.in-st[app.lg]
						<input type="number" inputmode="numeric" bind=steps placeholder="Enter value">
					<label> app.trans.in-le[app.lg]
						<.plus-minus>
							<.mns-btn @click=levelforenergy-->
							<input type="number" inputmode="numeric" bind=levelforenergy placeholder="Enter value">
							<.pls-btn @click=levelforenergy++>
					<label[h:0 m:0 lh:0]>
				<.hab-list>
					<Habitat[fl: 1 0 240px] name=(app.trans.sub-hab[app.lg] + ' 2') id=2>
					<Habitat[fl: 1 0 240px] name=(app.trans.sub-hab[app.lg] + ' 1') id=1>
					<Habitat[fl: 1 0 240px] name=app.trans.gen-hab[app.lg] id=0>
			if harvestab == 'right'
				<form>
					<label> app.trans.in-le[app.lg]
						<.plus-minus>
							<.mns-btn @click=levelforsteps-->
							<input type="number" inputmode="numeric" bind=levelforsteps placeholder="Enter value">
							<.pls-btn @click=levelforsteps++>
					<label[h:0 m:0 lh:0]>
					<label[h:0 m:0 lh:0]>
				<.hab-list>
					<Habitat name=(app.trans.sub-hab[app.lg] + ' 2') id=5>
					<Habitat name=(app.trans.sub-hab[app.lg] + ' 1') id=4>
					<Habitat name=app.trans.gen-hab[app.lg] id=3>
		<.block.results>
			if harvestab == 'left'
				<.results-data>
					<.cap>
						<h1 .notranslate> app.SpaceNum(app.EnergyFromSteps(steps, levelforenergy))
						<p> app.trans.en-earn[app.lg]
					<.cap>
						<h1 .notranslate> app.DailyCap(0)
						<p> app.trans.ki-cap[app.lg]
					<.cap>
						<h1 .notranslate> KiCap(0.02)
						<p> app.trans.ki14[app.lg]
						# <p> 'Energy Remaining '
						# 	<span> RemainEn(0.02)
					<.cap>
						<h1 .notranslate> KiCap(0.0143)
						<p> app.trans.ki10[app.lg]
						# <p> 'Energy Remaining '
						# 	<span> RemainEn(0.0143)
					<.cap>
						<h1 .notranslate> KiCap(0.0095)
						<p> app.trans.ki7[app.lg]
						# <p> 'Energy Remaining '
						# 	<span> RemainEn(0.0095)
			if harvestab == 'right'
				<.results-data>
					<.cap>
						<h1 .notranslate> app.DailyCap(3)
						<p> app.trans.ki-harv[app.lg]
						# <span> '$' + (app.DailyCap(3) * app.rates.ki).toFixed(4)
					<.cap>
						<h1 .notranslate> NeededSteps(0.02)
						<p> app.trans.steps14[app.lg]
					<.cap>
						<h1 .notranslate> NeededSteps(0.0143)
						<p> app.trans.steps10[app.lg]
					<.cap>
						<h1 .notranslate> NeededSteps(0.0095)
						<p> app.trans.steps7[app.lg]